import React from "react";
import MUIBox from "@material-ui/core/Box";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    "& > :last-child": {
      marginRight: 0,
    },
    "& > *": {
      marginRight: theme.spacing(2),
      flexBasis: 1,
      flexGrow: 1,
    },
  },
}));

const BoxActions = ({ children }) => {
  const classes = useStyles();

  return <MUIBox classes={{ root: classes.root }}>{children}</MUIBox>;
};

export default BoxActions;
